import { FeatureFlagName } from '@/api/gen/featureFlagName';
import { useFeatureFlagContext } from '@/contexts/featureFlagContext';

export const useNetworkStatusNotificationDeterminer = () => {
  const { isFeatureEnabled } = useFeatureFlagContext();
  const isNetworkIssueNotificationBarEnabled = isFeatureEnabled(FeatureFlagName.Y25Q3_NetworkIssueNotificationBar);

  return isNetworkIssueNotificationBarEnabled;
};
